import React from 'react'
import styled from 'styled-components'

export const Heading = {}

Heading.H4 = styled.h4``
